import React from "react";
import { useTheme } from "../config/ThemeContext";

const SetEndDialog = ({ show, currentSet, onConfirm }) => {
  const theme = useTheme();

  if (!show) return null;

  return (
    <div className={`fixed top-24 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md mx-auto p-6 rounded-lg shadow-xl border ${theme.primary.border} ${theme.primary.lightBg}`}>
      <h2 className={`text-xl font-semibold mb-3 text-center ${theme.primary.text}`}>
        Confirm End of Set
      </h2>
      <p className="text-center text-gray-700 mb-6">
        Are you sure you want to end Set {currentSet}?
      </p>
      <div className="flex justify-center gap-4">
        <button
          onClick={() => onConfirm(true)}
          className={`px-4 py-2 rounded font-medium text-white ${theme.primary.bg} ${theme.primary.hover}`}
        >
          Yes
        </button>
        <button
          onClick={() => onConfirm(false)}
          className={`px-4 py-2 rounded font-medium border ${theme.primary.border} ${theme.primary.text} ${theme.primary.hover}`}
        >
          No
        </button>
      </div>
    </div>
  );
};

export default SetEndDialog;
